import { Flex, Heading } from "@instructure/ui";
import { useTranslation } from "react-i18next";
import { EMPTY_RTE } from "../../../CustomTextArea/CustomRTE";
import RichTextEditor from "../../../RichTextArea/RichTextEditor";
import RichTextViewer from "../../../RichTextArea/RichTextViewer";

const QualitativePreview = ({ measure, key1, key2 }) => {
  const { t } = useTranslation();

  return (
    <Flex direction="column" gap="small">
      <Flex.Item>
        <Heading level="h3">
          {`${measure.name ?? t("assessment.qualitativeMeasure")}`}{" "}
        </Heading>
      </Flex.Item>
      {((measure.instructions && measure.instructions !== EMPTY_RTE) ||
        measure.description) && (
        <Flex.Item padding="0 0 0 large">
          <RichTextViewer
            value={
              measure.instructions ? measure.instructions : measure.description
            }
            ariaLabel={t("assessment.instructions")}
          />
        </Flex.Item>
      )}
      <Flex.Item padding="0 0 0 large">
        <RichTextEditor
          id={`preview-measure-${key1}-${key2}`}
          label={<Heading level="h4">{t("results.measureEvidence")}</Heading>}
          defaultValue={t("results.measurePreviewHtml")}
          uneditable
        />
      </Flex.Item>
    </Flex>
  );
};

export default QualitativePreview;
